import { Box, Picture } from "components/common"
import { jewlr_t } from "helpers/application"
import {
  LinkBlock,
  SectionDescription,
  SectionLink,
  SectionTitle,
} from "jewlr/pages/components"

const SaleForHer = () => (
  <Box mb={{ _: 4, desktop: 6 }} textAlign="center">
    <SectionTitle>On Sale For Her</SectionTitle>
    <SectionDescription>
      Discover great deals on {jewlr_t("terms.personalized")}{" "}
      {jewlr_t("terms.jewelry")}.
    </SectionDescription>
    <LinkBlock data-lc="sale-for-her" mb={3} to="/sale-for-her">
      <Picture
        fallback={`${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/sale-for-her/desktop_2x.jpg`}
        srcSet={[
          {
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/sale-for-her/mobile.jpg 767w,
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/sale-for-her/mobile_2x.jpg 1534w
            `,
          },
          {
            media: "(min-width: 768px)",
            sizes: "100vw",
            srcSet: `
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/sale-for-her/desktop.jpg 590w,
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/sale-for-her/desktop_2x.jpg 1180w
            `,
          },
        ]}
      />
    </LinkBlock>
    <SectionLink data-lc="sale-for-her" to="/sale-for-her">
      Shop Now
    </SectionLink>
  </Box>
)

export default SaleForHer
